import {Link} from "@nextui-org/react";

import TitleTemplate from "@/components/shared/title-template";

const color = ['bg-[#1C80DC]', 'bg-[#0AA3D3]', 'bg-[#E5310A]', 'bg-[#0FB21F]', 'bg-[#9747FF]', 'bg-[#42f5b9]', 'bg-[#f5ef42]', 'bg-[#eb8e1c]', 'bg-[#eb1ce8]', 'bg-[#eb1c8e]', "bg-[#0FB21F]"]

export default function Categories({categories, categoryCode}) {
    if (categories?.length === 0) {
        return <></>
    }

    const minLevel = categories.reduce((compare, e) => compare = Math.min(compare, e.level), Number.MAX_VALUE);
    const mainCategory = categories.find((e) => e.level === minLevel);
    const subCategories = categories.filter((e) => e.level > minLevel);

    return (
        <div className="shadow-lg rounded-[5px] bg-white">
            <TitleTemplate titleName={mainCategory?.name} link={mainCategory.type === 'categories' ? `/chuyen-muc/${mainCategory.code}` : mainCategory.link} />

            <div className="px-2">
                {/* TODO: ScrollShadow - Check active*/}
                {
                    subCategories.length !== 0 ?
                        subCategories.map((item, idx) => {
                            let isHighlight = categoryCode === item.code;
                            return (
                                <div key={idx}
                                    className={`flex justify-between items-center pl-1 rounded-lg ${isHighlight? 'bg-secondary shadow-lg' : ''}`}>
                                    <Link href={item.type === 'categories' ? `/chuyen-de/${item.code}` : item.link} className={ `h-10`}>
                                        <span>{item.name}</span>
                                    </Link>
                                </div>
                            );
                        }) : null
                }
            </div>
        </div>
    );
}